import EnumObject from '@/domain/enum-object.entity';
import RuleScriptParameter from './rule-script-parameter.entity';

export default class RuleScript {
  id: string;

  name: string;

  description: string;

  status: EnumObject;

  type: string = 'JAVA_SCRIPT'

  createdAt: string;

  script: string;

  parameters: RuleScriptParameter[];

  ruleType: string;

  versionAtual: number | null;

  dataSourceId: string | null;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.description = obj.description || '';
    this.createdAt = obj.createdAt || '';
    this.script = obj.script || '';
    this.status = EnumObject.of(obj.status);
    this.parameters = obj.parameters ? RuleScriptParameter.ofList(obj.parameters) : [];
    this.ruleType = obj.ruleType || '';
    this.versionAtual = obj.versionAtual || null;
    this.dataSourceId = obj.dataSourceId || null;
  }

  public static of(obj: any = {}): RuleScript {
    return new RuleScript(obj);
  }

  public static ofList(obj: any[] = []): RuleScript[] {
    return obj.map(this.of);
  }

  isApproved(): boolean {
    return this.status.value === 'APPROVED';
  }

  approve() {
    this.status = EnumObject.of({ value: 'APPROVED', description: 'Aprovado' });
  }

  get approvedStatusIcon(): object {
    return {
      color: 'greenPrimary',
      label: 'Aprovado',
    }
  }

  get waitingForApprovalIcon(): object {
    return {
      color: 'warning',
      label: 'Aguardando aprovação',
    }
  }

  getStatusIconAndLabel() {
    return this.isApproved()
      ? this.approvedStatusIcon
      : this.waitingForApprovalIcon;
  }

  addParameter() {
    this.parameters.push(RuleScriptParameter.of({ index: this.parameters.length }));
  }

  removeParameter(parameter: RuleScriptParameter) {
    this.parameters.splice(this.parameters.indexOf(parameter), 1)
  }

  updateIndexUp(parameter: RuleScriptParameter) {
    const from = this.parameters.indexOf(parameter);
    const to = from - 1
    if (to < 0) {
      return;
    }

    this.parameters.splice(to, 0, this.parameters.splice(from, 1)[0]);
    this.parameters.forEach((el: RuleScriptParameter, index) => {
      el.index = index
    })
  }

  updateIndexDown(parameter: RuleScriptParameter) {
    const from = this.parameters.indexOf(parameter);
    const to = from + 1
    if (to > this.parameters.length) {
      return;
    }

    this.parameters[from].index = to
    this.parameters.splice(to, 0, this.parameters.splice(from, 1)[0]);
    this.parameters.forEach((el: RuleScriptParameter, index) => {
      el.index = index
    })
  }

  hasParameter() {
    return this.parameters.length !== 0;
  }

  hasScript() {
    return this.script !== '';
  }

  getRuleTypeDescription() {
    return this.ruleType === 'FIXED'
      ? 'Fixo'
      : 'Variável'
  }
}
